import * as actions from 'actions';
import {useDispatch, useSelector} from "react-redux";

const useLoading = () => {
    const dispatch = useDispatch();
    const loadingCount = useSelector(state => state.loadingCount);
    const loadStart = () => {
        dispatch(actions.addLoadingCount());
    };

    const loadEnd = () => {
        dispatch(actions.deleteLoadingCount());
    };

    return {loadingCount, loadStart, loadEnd};
};

export default useLoading;